var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Award',{attrs:{"awardData":_vm.awardData,"tpl":_vm.tpl}})
}
var staticRenderFns = []

export { render, staticRenderFns }